import { styles } from 'gipsy-misc'

export const transitionDurationMs = styles.transitions.calendarSlide * 1000
